import React from 'react'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import About from './components/About'
import Footer from './components/Footer'
import Products from './components/Products'
import Clients from './components/Clients'
import Certificates from './components/Certificates'
import Contact from './components/Contact'
// import FlatWiresAndProfiles from './components/products/FlatWiresAndProfiles'

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <About />
      <Products />
      <Clients />
      <Certificates />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
